import { Box, Skeleton } from "@mui/material";

const styles = () => {
  return {
    display: "flex",
    justifyContent: "space-between",
    height: "30px",
    padding: "2px",
    "& .MuiSkeleton-root": {
      minHeight: "24px",
      padding: 0,
      margin: 0,
      width: "24%",
    },
  };
};

const WindowSelectorLoader = () => {
  return (
    <Box sx={styles} mb={1}>
      <Skeleton variant="rectangular" animation="wave" />
      <Skeleton variant="rectangular" animation="wave" />
      <Skeleton variant="rectangular" animation="wave" />
      <Skeleton variant="rectangular" animation="wave" />
    </Box>
  );
};

export default WindowSelectorLoader;
